<template>
  <div ref="container" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  cookiebotId: string
}

const props = defineProps<Props>()

const i18n = useI18n()
const container = ref<HTMLElement | null>(null)

onMounted(() => {
  if (!container.value) {
    return
  }

  const script = document.createElement('script')
  script.id = 'CookiePolicy'
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://consent.cookiebot.com/${props.cookiebotId}/cd.js`
  script.dataset.culture = i18n.locale.value.toUpperCase()

  container.value.appendChild(script)
})
</script>
